/**
 * Created by SG0949773 on 10/19/2015.
 */
'use strict';

var ConfigurationEntityDirective = function ConfigurationEntityDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/configurationEntity.html'),
    controller: 'ConfigurationEntityController',
    link: function link(scope) {
      scope.$on('configuration-entity:saveChanges', scope.saveChanges);
      scope.$on('configuration-entity:loadedSuccessful', scope.loadedSuccessful);
      scope.$on('configuration-entity:removeEntity', scope.removeEntity);
    }
  };
};
ConfigurationEntityDirective.$inject = [];
module.exports = ConfigurationEntityDirective;